import React, {Component} from 'react';
import {Alert, Container, Row, Col, CardGroup, Card, CardBody, CardFooter, Button, Input, FormGroup, FormFeedback, Form, Label} from 'reactstrap';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {signUp as APISignup} from '../../../gateways/account_management'
import {USA_STATES, SURVEY_TYPES, DEFAULT_PRICES} from '../../../constants'
import './SignUp.scss';

class SignUp extends Component {

  constructor(props) {
    super(props);
    this.state = {
      singUpSuccess: false,
      formPersonal: {
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        confirmPassword: '',
        isEmailResult: false,
        isHardCopyResult: false,
        joinSurveys: true
      },
      formProperty: {
        propertyName: '',
        propertyAddress: '',
        city: '',
        state: '',
        surveyType: '',
        surveyTypeText: '',
        zipCode: '',
        phoneNumber: '',
        faxNumber: '',
        contactName: '',
        contactTitle: '',
        contactEmail: '',
        generalManagerName: '',
        numberOfRooms: '',
        luxury: false,
        union: false,
        inn: false,
        golf: false,
        limited: false,
        zone: '1'
      },
      formError: {
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        confirmPassword: '',
        joinSurveys: '',
        propertyName: '',
        propertyAddress: '',
        city: '',
        state: '',
        surveyType: '',
        surveyTypeText: '',
        zipCode: '',
        phoneNumber: '',
        faxNumber: '',
        contactName: '',
        contactTitle: '',
        contactEmail: '',
        generalManagerName: '',
        numberOfRooms: '',
        luxury: '',
        union: '',
        inn: '',
        golf: '',
        limited: '',
        zone: '',
      },
      alert: {
        message: "",
        color: ""
      },
      surveyTypes: [],
      zones: [],
      showLuxury: true,
      showUnion: true,
      showInn: false,
      showGolf: false,
      showLimited: false,
      selectedSurveyType: null
    }
  }

  setFormPersonalValue(field, value) {
    this.setState({
      "formPersonal": {
        ...this.state.formPersonal,
        [field]: value
      }
    }, () => {
      if ( this.state.formError[field] !== '' )
        this.validateInput(field, this.state.formPersonal[field])
    });
  }

  setFormPropertyValue(field, value) {
    return new Promise((resolve, reject) => {
      this.setState({
        "formProperty": {
          ...this.state.formProperty,
          [field]: value
        }
      }, () => {
        if ( this.state.formError[field] !== '' )
          this.validateInput(field, this.state.formProperty[field])
        resolve();
      });
    });
  }

  generateSurveyTypes(state) {
    let surveyTypes = SURVEY_TYPES.filter((surveyType) => {
      return surveyType.state === 'ALL' || surveyType.state === state;
    });
    this.setState({
      surveyTypes: surveyTypes,
      "formProperty": {
        ...this.state.formProperty
      }
    }, () => {
      this.onChangeSurveyType();
    });
  }

  onChangeState(value) {
    this.setFormPropertyValue("state", value)
    .then(() => {
      this.setState({
        "formProperty": {
          ...this.state.formProperty
        }
      }, () => {
        this.generateSurveyTypes(value);
      });
    });
  }

  onChangeSurveyType(value) {
    let surveyType = SURVEY_TYPES.find((item) => {
      return value === item.key;
    });
    if ( surveyType ) {
      this.setFormPropertyValue("surveyType", value)
      .then(() => {
        this.setFormPropertyValue("surveyTypeText", surveyType.name)
        this.setState({
          selectedSurveyType: surveyType,
          showLuxury: surveyType.has_luxury,
          showUnion: surveyType.has_union,
          showInn: surveyType.has_inn,
          showGolf: surveyType.has_golf,
          showLimited: surveyType.has_limited,
          zones: surveyType.zones,
          formProperty: {
            ...this.state.formProperty,
            luxury: surveyType.has_luxury ? this.state.formProperty.luxury : false,
            union: surveyType.has_union ? this.state.formProperty.union : false,
            inn: surveyType.has_inn ? this.state.formProperty.inn : false,
            golf: surveyType.has_golf ? this.state.formProperty.golf : false,
            limited: surveyType.has_limited ? this.state.formProperty.limited : false
          }
        });
      });
    } else {
      this.setFormPropertyValue("surveyTypeText", "")
      this.setState({
        selectedSurveyType: null,
        showLuxury: true,
        showUnion: true,
        showInn: true,
        showGolf: true,
        showLimited: true,
        zones: [],
        formProperty: {
          ...this.state.formProperty,
          surveyType: '',
          luxury: false,
          union: false,
          inn: false,
          golf: false,
          limited: false
        }
      });
    }
  }

  setFormError(field, message) {
    this.setState({
      "formError": {
        ...this.state.formError,
        [field]: message
      }
    });
  }

  signUp() {
    if ( this.validateInputs() ) {
      APISignup({
        ...this.state.formPersonal,
        ...this.state.formProperty
      }).then((result) => {
        if ( !result.error ) {
          this.setState({ 'singUpSuccess': true });
        } else {
          if ( typeof result.msg !== 'undefined' ) {
            let msg = result.msg;
            if ( Array.isArray(result.msg) ) {
              msg = result.msg.map(m => m.msg).join(" ");
            }
            this.setState({ 'alert': {
              "message": msg,
              "color": "danger"
            }});
          } else {
            this.setState({ 'alert': {
              "message": "Something went wrong. Please contact administrator.",
              "color": "danger"
            }});
          }
        }
      }).catch((error) => {
        let message = "";
        if ( error.response && error.response.data ) {
          message = error.response.data.message;
        } else {
          message = error.message;
        }
        this.setState({ 'alert': {
          "message": message,
          "color": 'danger'
        }});
      });
    }
  }

  validateInput(field, value) {
    const fieldValidations = this.getFieldValidations();
    let result = this.validateMultipleRules(fieldValidations[field], value);
    if ( !result.pass ) {
      this.setFormError(field, result.messages.join(' '));
    } else {
      this.setFormError(field, '');
    }
    return result.pass;
  }

  validateInputs() {
    let pass = true;
    let errors = {};

    const fieldValidations = this.getFieldValidations();

    Object.keys(this.state.formPersonal).map((key) => {

      let result = this.validateMultipleRules(fieldValidations[key], this.state.formPersonal[key]);
      if ( !result.pass ) {
        pass = false;
        errors[key] = result.messages.join(' ');
      } else {
        errors[key] = "";
      }
    });

    if ( this.state.formPersonal.joinSurveys ) {
      Object.keys(this.state.formProperty).map((key) => {
        let validations = fieldValidations[key];
        if ( key === 'surveyType' ) {
          validations = this.state.surveyTypes.length > 0 ? validations : [];
        }
        let result = this.validateMultipleRules(validations, this.state.formProperty[key]);
        if ( !result.pass ) {
          pass = false;
          errors[key] = result.messages.join(' ');
        } else {
          errors[key] = "";
        }
      });
    }

    if ( !pass ) {
      this.setState({
        "formError": {
          ...this.state.formError,
          ...errors
        }
      });
    }

    return pass;
  }

  validateMultipleRules(rules, value) {
    let pass = true;
    let messages = [];
    if ( !Array.isArray(rules) ) {
      rules = [rules];
    }
    for (var i = 0; i < rules.length; i++) {
      let result = this.validate(rules[i], value);

      if ( !result.pass ) {
        pass = false;
        messages.push(result.message);
      }

    }
    return { pass: pass, messages: messages };
  }

  validate(rule, value) {
    let type = rule;
    let pass = true;
    let message = "";
    if ( typeof rule === "object" ) {
      type = rule.type;
    }
    switch (type) {
      case "email":
        pass = value !== '' ? /(.+)@(.+){2,}\.(.+){2,}/.test(value) : true;
        if ( !pass ) {
          message = "Invalid email address.";
        }
        break;
      case "max":
        pass = value.length <= rule.value;
        if ( !pass ) {
          message = "Value must not longer then " + rule.value + " character(s).";
        }
        break;
      case "confirmPassword":
        pass = value === this.state.formPersonal.password;
        if ( !pass ) {
          message = "Password and Confirm password don't match."
        }
        break;
      case "required":
        pass = value !== '' && value !== null;
        if ( !pass ) {
          message = "This field is required.";
        }
        break;
      case "number":
        pass = !isNaN(value);
        if ( !pass ) {
          message = "Must be a number";
        }
        break;
      default:
        break;
    }
    return { pass: pass, message: message };
  }

  getFieldValidations() {
    return {
      "email": ["email", "required"],
      "firstName": ["required", { "type": "max", "value": 255 }],
      "lastName": ["required", { "type": "max", "value": 255 }],
      "password": ["required", { "type": "min", "value": 8 }],
      "confirmPassword": ["required", "confirmPassword"],
      "propertyName": ["required", { "type": "max", "value": 255 }],
      "propertyAddress": ["required", { "type": "max", "value": 255 }],
      "city": ["required", { "type": "max", "value": 50 }],
      "state": ["required", { "type": "max", "value": 50 }],
      "surveyType": ["required"],
      "zipCode": ["required", { "type": "max", "value": 50 }],
      "phoneNumber": ["required", { "type": "max", "value": 50 }],
      "faxNumber": [{ "type": "max", "value": 50 }],
      "contactName": ["required",{ "type": "max", "value": 255 }],
      "contactTitle": ["required",{ "type": "max", "value": 255 }],
      "contactEmail": ["required","email"],
      "generalManagerName": ["required", { "type": "max", "value": 255 }],
      "numberOfRooms": ["required", "number"],
      "luxury": ["required"],
      "union": ["required"],
      "inn": ["required"],
      "golf": ["required"],
      "limited": ["required"],
      "zone": ["required"]
    };
  }

  renderSurveyTypes() {
    if ( this.state.surveyTypes.length > 0 ) {
      return (
        <FormGroup row>
          <Col md="3">
            <Label>Survey Type</Label>
          </Col>
          <Col xs="12" md="9">
            <Input
              type="select"
              name="survey_type"
              value={this.state.formProperty.surveyType}
              placeholder="Survey Type"
              valid={this.state.formError.surveyType ? false: null}
              invalid={this.state.formError.surveyType ? true: null}
              onChange={(e) => { this.onChangeSurveyType(e.target.value) }}>
              <option value="">Please select</option>
              {this.state.surveyTypes.map( (type, index) => {
                return (
                  <option key={type.key} value={type.key}>{type.name}</option>
                )
              } )}
            </Input>
            <Input
              type="hidden"
              name="survey_type_text"
              value={this.state.formProperty.surveyTypeText}>
            </Input>
            <FormFeedback>{this.state.formError.surveyType}</FormFeedback>
          </Col>
        </FormGroup>
      );
    }
  }

  onAlertDismiss() {
    this.setState({
      alert: {
        message: "",
        color: ""
      }
    });
  }

  renderPropertyForm() {
    if ( this.state.formPersonal.joinSurveys ) {

      return (
        <div className="animated fadeIn">
          <FormGroup row>
            <Col md="3">
              <Label>Property name</Label>
            </Col>
            <Col xs="12" md="9">
              <Input
                type="text"
                name="property_name"
                value={this.state.formProperty.propertyName}
                placeholder="Property name"
                valid={this.state.formError.propertyName ? false: null}
                invalid={this.state.formError.propertyName ? true: null}
                onChange={(e) => { this.setFormPropertyValue("propertyName", e.target.value) }}/>
              <FormFeedback>{this.state.formError.propertyName}</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="3">
              <Label>Property address</Label>
            </Col>
            <Col xs="12" md="9">
              <Input
                type="text"
                name="property_address"
                value={this.state.formProperty.propertyAddress}
                placeholder="Property address"
                valid={this.state.formError.propertyAddress ? false: null}
                invalid={this.state.formError.propertyAddress ? true: null}
                onChange={(e) => { this.setFormPropertyValue("propertyAddress", e.target.value) }}/>
              <FormFeedback>{this.state.formError.propertyAddress}</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="3">
              <Label>City</Label>
            </Col>
            <Col xs="12" md="9">
              <Input
                type="text"
                name="city"
                value={this.state.formProperty.city}
                placeholder="City"
                valid={this.state.formError.city ? false: null}
                invalid={this.state.formError.city ? true: null}
                onChange={(e) => { this.setFormPropertyValue("city", e.target.value) }}/>
              <FormFeedback>{this.state.formError.city}</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="3">
              <Label>State</Label>
            </Col>
            <Col xs="12" md="9">
              <Input
                type="select"
                name="state"
                value={this.state.formProperty.state}
                placeholder="State"
                valid={this.state.formError.state ? false: null}
                invalid={this.state.formError.state ? true: null}
                onChange={(e) => { this.onChangeState(e.target.value) }}>
                <option value="">Please select</option>
                {USA_STATES.map( (state, index) => {
                  return (
                    <option key={state.key} value={state.key}>{state.name}</option>
                  )
                } )}
              </Input>
              <FormFeedback>{this.state.formError.state}</FormFeedback>
            </Col>
          </FormGroup>
          {this.renderSurveyTypes()}
          <FormGroup row>
            <Col md="3">
              <Label>Zip code</Label>
            </Col>
            <Col xs="12" md="9">
              <Input
                type="text"
                name="zip_code"
                value={this.state.formProperty.zipCode}
                placeholder="Zip code"
                valid={this.state.formError.zipCode ? false: null}
                invalid={this.state.formError.zipCode ? true: null}
                onChange={(e) => { this.setFormPropertyValue("zipCode", e.target.value) }}/>
              <FormFeedback>{this.state.formError.zipCode}</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="3">
              <Label>Phone number</Label>
            </Col>
            <Col xs="12" md="9">
              <Input
                type="text"
                name="phone_number"
                value={this.state.formProperty.phoneNumber}
                placeholder="Phone number"
                valid={this.state.formError.phoneNumber ? false: null}
                invalid={this.state.formError.phoneNumber ? true: null}
                onChange={(e) => { this.setFormPropertyValue("phoneNumber", e.target.value) }}/>
              <FormFeedback>{this.state.formError.phoneNumber}</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="3">
              <Label>Fax number</Label>
            </Col>
            <Col xs="12" md="9">
              <Input
                type="text"
                name="fax_number"
                value={this.state.formProperty.faxNumber}
                placeholder="Fax number"
                valid={this.state.formError.faxNumber ? false: null}
                invalid={this.state.formError.faxNumber ? true: null}
                onChange={(e) => { this.setFormPropertyValue("faxNumber", e.target.value) }}/>
              <FormFeedback>{this.state.formError.faxNumber}</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="3">
              <Label>Contact name</Label>
            </Col>
            <Col xs="12" md="9">
              <Input
                type="text"
                name="contact_name"
                value={this.state.formProperty.contactName}
                placeholder="Contact name"
                valid={this.state.formError.contactName ? false: null}
                invalid={this.state.formError.contactName ? true: null}
                onChange={(e) => { this.setFormPropertyValue("contactName", e.target.value) }}/>
              <FormFeedback>{this.state.formError.contactName}</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="3">
              <Label>Contact title</Label>
            </Col>
            <Col xs="12" md="9">
              <Input
                type="text"
                name="contact_title"
                value={this.state.formProperty.contactTitle}
                placeholder="Contact title"
                valid={this.state.formError.contactTitle ? false: null}
                invalid={this.state.formError.contactTitle ? true: null}
                onChange={(e) => { this.setFormPropertyValue("contactTitle", e.target.value) }}/>
              <FormFeedback>{this.state.formError.contactTitle}</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="3">
              <Label>Contact email</Label>
            </Col>
            <Col xs="12" md="9">
              <Input
                type="text"
                name="contact_email"
                value={this.state.formProperty.contactEmail}
                placeholder="Contact email"
                valid={this.state.formError.contactEmail ? false: null}
                invalid={this.state.formError.contactEmail ? true: null}
                onChange={(e) => { this.setFormPropertyValue("contactEmail", e.target.value) }}/>
              <FormFeedback>{this.state.formError.contactEmail}</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="3">
              <Label>General Manager</Label>
            </Col>
            <Col xs="12" md="9">
              <Input
                type="text"
                name="general_manager_name"
                value={this.state.formProperty.generalManagerName}
                placeholder="General Manager"
                valid={this.state.formError.generalManagerName ? false: null}
                invalid={this.state.formError.generalManagerName ? true: null}
                onChange={(e) => { this.setFormPropertyValue("generalManagerName", e.target.value) }}/>
              <FormFeedback>{this.state.formError.generalManagerName}</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="3">
              <Label>Number of rooms</Label>
            </Col>
            <Col xs="12" md="9">
              <Input
                type="text"
                name="number_of_rooms"
                value={this.state.formProperty.numberOfRooms}
                placeholder="Number of rooms"
                valid={this.state.formError.numberOfRooms ? false: null}
                invalid={this.state.formError.numberOfRooms ? true: null}
                onChange={(e) => { this.setFormPropertyValue("numberOfRooms", e.target.value) }}/>
              <FormFeedback>{this.state.formError.numberOfRooms}</FormFeedback>
            </Col>
          </FormGroup>
          {this.renderLuxuryPropertyField()}
          {this.renderUnionPropertyField()}
          {this.renderInnPropertyField()}
          {this.renderGolfPropertyField()}
          {this.renderLimitedPropertyField()}
          {this.renderZoneField()}
        </div>
      );
    }
  }

  renderRegistrationForm() {
    const prices = this.state.selectedSurveyType === null ? DEFAULT_PRICES : this.state.selectedSurveyType;
    return (
      <CardBody>
        <h1>Sign Up!</h1>
        <p className="text-muted">Create your account</p>
        <Alert color={this.state.alert.color} isOpen={this.state.alert.message != ""} toggle={() => this.onAlertDismiss()}>
          {this.state.alert.message}
        </Alert>
        <Form onSubmit={(e) => { e.preventDefault(); this.signUp(); }}>
          <FormGroup row>
            <Col md="3">
              <Label>Email</Label>
            </Col>
            <Col xs="12" md="9">
              <Input
                type="text"
                name="email"
                value={this.state.formPersonal.email}
                placeholder="Email"
                valid={this.state.formError.email ? false: null}
                invalid={this.state.formError.email ? true: null}
                onChange={(e) => { this.setFormPersonalValue("email", e.target.value) }}/>
              <FormFeedback>{this.state.formError.email}</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="3">
              <Label>First name</Label>
            </Col>
            <Col xs="12" md="9">
              <Input
                type="text"
                name="firstname"
                value={this.state.formPersonal.firstName}
                placeholder="First name"
                valid={this.state.formError.firstName ? false: null}
                invalid={this.state.formError.firstName ? true: null}
                onChange={(e) => { this.setFormPersonalValue("firstName", e.target.value) }}/>
              <FormFeedback>{this.state.formError.firstName}</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="3">
              <Label>Last name</Label>
            </Col>
            <Col xs="12" md="9">
              <Input
                type="text"
                name="lastname"
                value={this.state.formPersonal.lastName}
                placeholder="Last name"
                valid={this.state.formError.lastName ? false: null}
                invalid={this.state.formError.lastName ? true: null}
                onChange={(e) => { this.setFormPersonalValue("lastName", e.target.value) }}/>
              <FormFeedback>{this.state.formError.lastName}</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="3">
              <Label>Password</Label>
            </Col>
            <Col xs="12" md="9">
              <Input
                type="password"
                name="password"
                value={this.state.formPersonal.password}
                placeholder="Password"
                valid={this.state.formError.password ? false: null}
                invalid={this.state.formError.password ? true: null}
                onChange={(e) => { this.setFormPersonalValue("password", e.target.value) }}/>
              <FormFeedback>{this.state.formError.password}</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="3">
              <Label>Confirm password</Label>
            </Col>
            <Col xs="12" md="9">
              <Input
                type="password"
                name="confirmPassword"
                value={this.state.formPersonal.confirmPassword}
                placeholder="Confirm password"
                valid={this.state.formError.confirmPassword ? false: null}
                invalid={this.state.formError.confirmPassword ? true: null}
                onChange={(e) => { this.setFormPersonalValue("confirmPassword", e.target.value) }}/>
                <FormFeedback>{this.state.formError.confirmPassword}</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col md="3">
            </Col>
            <Col xs="12" md="9">
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    name="join_surveys"
                    value={this.state.formPersonal.joinSurveys}
                    checked={this.state.formPersonal.joinSurveys ? true : false}
                    onChange={(e) => { this.setFormPersonalValue("joinSurveys", e.target.checked) }}/>
                    I want to participate
                </Label>
              </FormGroup>
            </Col>
          </FormGroup>
          <Row>
            <Col xs="12" md="9">
                <h5>
                  RESULTS INFORMATION:<br/>
                  <small>We wish our results to be sent back to us as follows :</small>
                </h5>
            </Col>
          </Row>
          <Row>
            <Col xs="12" md="9">
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    name="is_email_result"
                    value={this.state.formPersonal.isEmailResult}
                    onChange={(e) => { this.setFormPersonalValue("isEmailResult", e.target.checked) }}/>
                    Via Email (no additional charge)
                </Label>
              </FormGroup>
            </Col>
          </Row>
          {/* <Row>
            <Col xs="12" md="9">
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    name="is_hard_copy_result"
                    value={this.state.formPersonal.isHardCopyResult}
                    onChange={(e) => { this.setFormPersonalValue("isHardCopyResult", e.target.checked) }}/>
                    Via Hard Copy Manual (additional cost-please inquire)
                </Label>
              </FormGroup>
            </Col>
          </Row> */}
          <br />
          {this.renderPropertyForm()}
          <Row>
            <Col xs="12" md="12">
                <h5>
                  <small>The information contained in all of the benefits &amp; Compensation survey reports is reported voluntarily by participating properties. While Executive HR Consulting Group believes the information to be accurate, it does not audit the information and therefore does not warrant its accuracy in any way.</small>
                  <br /><br />
                  <small>By participating in this survey or purchasing the survey results as a “non-participant, you understand and agree that the survey results are proprietary and confidential between you and ECG. You further agree to maintain confidentiality of the results, not to hold ECG liable for producing the survey results and agree not to share the information with any other hotel or entity.</small>
                  <br /><br />
                  <small>By clicking “Register”, you agree to the above statement.</small>
                </h5>
            </Col>
          </Row>
          <FormGroup row>
            <Button type="submit" color="success" block>Register</Button>
          </FormGroup>
          <FormGroup row>
            <Link to='/login'><Button color="link">Back to Login</Button></Link>
          </FormGroup>
        </Form>
      </CardBody>
    );
  }

  convertToCurrency(value) {
    return parseFloat(Math.round(value * 100) / 100).toFixed(2);
  }

  renderLuxuryPropertyField() {
    if ( this.state.showLuxury ) {
      return (
        <FormGroup row>
          <Col md="3">
            <Label>Luxury Property</Label>
          </Col>
          <Col xs="12" md="9">
            <FormGroup check inline>
              <div className="radio">
                <Label check>
                  <Input type="radio" name="luxury" value="yes"
                    checked={this.state.formProperty.luxury}
                    valid={this.state.formError.luxury ? false: null}
                    invalid={this.state.formError.luxury ? true: null}
                    onChange={(e) => { this.setFormPropertyValue("luxury", true) }}/>
                  Yes
                </Label>
              </div>
            </FormGroup>
            <FormGroup check inline>
              <div className="radio">
                <Label check>
                  <Input type="radio" name="luxury" value="no"
                    checked={!this.state.formProperty.luxury}
                    valid={this.state.formError.luxury ? false: null}
                    invalid={this.state.formError.luxury ? true: null}
                    onChange={(e) => { this.setFormPropertyValue("luxury", false) }}/>
                  No
                </Label>
              </div>
            </FormGroup>
          </Col>
        </FormGroup>
      );
    }
  }

  renderUnionPropertyField() {
    if ( this.state.showUnion ) {
      return (
        <FormGroup row>
          <Col md="3">
            <Label>Union Property</Label>
          </Col>
          <Col xs="12" md="9">
            <FormGroup check inline>
              <div className="radio">
                <Label check>
                  <Input type="radio" name="union" value="yes"
                    checked={this.state.formProperty.union}
                    valid={this.state.formError.union ? false: null}
                    invalid={this.state.formError.union ? true: null}
                    onChange={(e) => { this.setFormPropertyValue("union", true) }}/>
                  Yes
                </Label>
              </div>
            </FormGroup>
            <FormGroup check inline>
              <div className="radio">
                <Label check>
                  <Input type="radio" name="union" value="no"
                    checked={!this.state.formProperty.union}
                    valid={this.state.formError.union ? false: null}
                    invalid={this.state.formError.union ? true: null}
                    onChange={(e) => { this.setFormPropertyValue("union", false) }}/>
                  No
                </Label>
              </div>
            </FormGroup>
          </Col>
        </FormGroup>
      );
    }
  }

  renderInnPropertyField() {
    if ( this.state.showInn ) {
      return (
        <FormGroup row>
          <Col md="3">
            <Label>Inn &/or Mid-Range Service Property</Label>
          </Col>
          <Col xs="12" md="9">
            <FormGroup check inline>
              <div className="radio">
                <Label check>
                  <Input type="radio" name="inn" value="yes"
                    checked={this.state.formProperty.inn}
                    valid={this.state.formError.inn ? false: null}
                    onChange={(e) => { this.setFormPropertyValue("inn", true) }}/>
                  Yes
                </Label>
              </div>
            </FormGroup>
            <FormGroup check inline>
              <div className="radio">
                <Label check>
                  <Input type="radio" name="inn" value="no"
                    checked={!this.state.formProperty.inn}
                    valid={this.state.formError.inn ? false: null}
                    invalid={this.state.formError.inn ? true: null}
                    onChange={(e) => { this.setFormPropertyValue("inn", false) }}/>
                  No
                </Label>
              </div>
            </FormGroup>
          </Col>
        </FormGroup>
      );
    }
  }

  renderGolfPropertyField() {
    if ( this.state.showGolf ) {
      return (
        <FormGroup row>
          <Col md="3">
            <Label>Golf-Related Positions Only Property</Label>
          </Col>
          <Col xs="12" md="9">
            <FormGroup check inline>
              <div className="radio">
                <Label check>
                  <Input type="radio" name="golf" value="yes"
                    checked={this.state.formProperty.golf}
                    valid={this.state.formError.golf ? false: null}
                    onChange={(e) => { this.setFormPropertyValue("golf", true) }}/>
                  Yes
                </Label>
              </div>
            </FormGroup>
            <FormGroup check inline>
              <div className="radio">
                <Label check>
                  <Input type="radio" name="golf" value="no"
                    checked={!this.state.formProperty.golf}
                    valid={this.state.formError.golf ? false: null}
                    invalid={this.state.formError.golf ? true: null}
                    onChange={(e) => { this.setFormPropertyValue("golf", false) }}/>
                  No
                </Label>
              </div>
            </FormGroup>
          </Col>
        </FormGroup>
      );
    }
  }

  renderLimitedPropertyField() {
    if ( this.state.showLimited ) {
      return (
        <FormGroup row>
          <Col md="3">
            <Label>Limited Service Property</Label>
          </Col>
          <Col xs="12" md="9">
            <FormGroup check inline>
              <div className="radio">
                <Label check>
                  <Input type="radio" name="limited" value="yes"
                    checked={this.state.formProperty.limited}
                    valid={this.state.formError.limited ? false: null}
                    onChange={(e) => { this.setFormPropertyValue("limited", true) }}/>
                  Yes
                </Label>
              </div>
            </FormGroup>
            <FormGroup check inline>
              <div className="radio">
                <Label check>
                  <Input type="radio" name="limited" value="no"
                    checked={!this.state.formProperty.limited}
                    valid={this.state.formError.limited ? false: null}
                    invalid={this.state.formError.limited ? true: null}
                    onChange={(e) => { this.setFormPropertyValue("limited", false) }}/>
                  No (Full Service)
                </Label>
              </div>
            </FormGroup>
          </Col>
        </FormGroup>
      );
    }
  }

  renderZoneField() {
    if ( this.state.zones.length > 0 ) {
      return (
        <FormGroup row>
          <Col md="3">
            <Label>Zone</Label>
          </Col>
          <Col xs="12" md="9">
            <FormGroup check>
              {this.state.zones.map( (zone, index) => {
                return (
                  <div key={zone.key} className="radio">
                    <Label check htmlFor={"zone" + zone.key}>
                      <Input type="radio" id={"zone" + zone.key} name="zone" value={zone.key}
                        checked={this.state.formProperty.zone === zone.key ? true : false}
                        valid={this.state.formError.zone ? false: null}
                        invalid={this.state.formError.zone ? true: null}
                        onChange={(e) => { this.setFormPropertyValue("zone", e.target.value) }}/>
                      {zone.name}
                    </Label>
                  </div>
                );
              })}
            </FormGroup>
          </Col>
        </FormGroup>
      );
    }
  }

  renderSignUpPage() {
    if ( this.state.singUpSuccess ) {
      return (
        <CardBody className="animated fadeIn">
          <h1>Congratulations!</h1>
          <p className="text-muted">You have registered to our service! We will contact you shortly.</p>
          <FormGroup row>
            <Link to='/'><Button color="link">Enter the site!</Button></Link>
          </FormGroup>
        </CardBody>
      );
    } else {
      return this.renderRegistrationForm();
    }
  }

  render() {
    const prices = this.state.selectedSurveyType
    return (
      <div className="SignUp app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col className="self-id" md="5">
              <Card className="p-0">
                {/* <img src="./img/self-id.png" /> */}
                <CardBody className="p-4">
                  <h5 className="pricelist-heading">Price</h5>
                  <Row>
                    <Col sm="8">
                      Participant
                    </Col>
                    <Col sm="4">
                      ${this.state.selectedSurveyType === null ? "" : this.convertToCurrency(prices.participant_price)}
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="8">
                      Non-Participant - Purchase Only
                    </Col>
                    <Col sm="4">
                      ${this.state.selectedSurveyType === null ? "" : this.convertToCurrency(prices.non_participant_price)}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col md="7">
              <Card className="p-4">
                {this.renderSignUpPage()}
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default SignUp;



// WEBPACK FOOTER //
// ./src/views/Pages/SignUp/SignUp.js